__turbopack_context__.v({
  "fullWidth": "JXUymG_fullWidth",
  "fullWidthBustOut": "JXUymG_fullWidthBustOut",
  "separator": "JXUymG_separator",
});
